<template>
  <form
    @submit.prevent="handleSubmit"
    name="company">
    <div class="col-md-6 padding-off">
      <div class="col-md-6">
        <!-- CNPJ -->
        <template v-if="company">
          <input-field
            :readonly="true"
            :submitted="submitted"
            :field.sync="form.document_number"
            :required="true"
            :mask="['##.###.###/####-##']"
            label="CNPJ"
            type="text"
            name="document_number"
            validate="required|min:14"></input-field>
        </template>
        <template v-else>
          <input-field
            :readonly="documentNumber.disabled"
            :submitted="submitted"
            :field.sync="form.document_number"
            :required="true"
            :mask="['##.###.###/####-##']"
            label="CNPJ"
            type="text"
            name="document_number"
            validate="required|min:14">
            <template
              v-if="documentNumber.error"
              slot:default>
              <span class="theme-form-error-message">{{ documentNumber.error }}</span>
            </template>
          </input-field>
        </template>
        <!-- / CNPJ -->
      </div>
      <div class="col-md-6">
        <fieldset :disabled="!company">
          <!-- Telefone fixo -->
          <input-field
            :submitted="submitted"
            :field.sync="form.phone"
            :required="true"
            :mask="['(##) ####-####', '(##) #####-####']"
            label="Telefone"
            type="tel"
            name="phone"
            validate="required"></input-field>
          <!-- / Telefone fixo -->
        </fieldset>
      </div>
      <fieldset :disabled="!company">
        <div class="col-md-12">
          <!-- Razão Social -->
          <input-field
            :submitted="submitted"
            :field.sync="form.name"
            :required="true"
            label="Razão Social"
            type="text"
            name="name"
            validate="required"></input-field>
          <!-- / Razão Social -->
        </div>
        <div class="col-md-12">
          <!-- Nome fantasia -->
          <input-field
            :submitted="submitted"
            :field.sync="form.fantasy_name"
            :required="false"
            label="Nome fantasia"
            type="text"
            name="fantasy_name"></input-field>
          <!-- / Nome fantasia -->
        </div>
        <div class="col-md-12 mb-20">
          <!-- Nome fantasia -->
          <input-field
            :submitted="submitted"
            :field.sync="form.url"
            :required="false"
            label="URL"
            type="text"
            name="url"></input-field>
          <!-- / Nome fantasia -->
        </div>
      </fieldset>
    </div>
    <div class="col-md-6 padding-off">
      <fieldset :disabled="!company">
        <address-form
          title=""
          :submitted="submitted"
          :form.sync="form.address"></address-form>
      </fieldset>
    </div>
    <div class="clearfix col-xs-12 padding-off">
      <div class="col-md-3 col-md-offset-6">
        <small>*Campos obrigatórios</small>
      </div>
      <div
        v-if="company"
        class="col-xs-12 col-md-3 mb-20">
        <button
          :disabled="loading"
          type="submit"
          class="btn-blue btn-block btn-extra-large">
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import InputField from '@/components/fields/InputField'
import AddressForm from '@/components/forms/AddressForm'
import { Company } from '@/models/Company'

export default {
  props: [
    'company',
    'loading'
  ],
  components: {
    InputField,
    AddressForm
  },
  data() {
    return {
      form: { ...Company },
      submitted: false,
      documentNumber: {
        disabled: false,
        error: false
      }
    }
  },
  watch: {
    company (data) {
      if (data) {
        this.form = { ...this.form, ...data }
        if (data.hasOwnProperty('address')) {
          this.form = {
            ...this.form,
            address: data.address
          }
        }
      }
    },
    'form.document_number' (data) {
      if (!this.company && data && data.length === 14) {
        this.handleDocumentNumber(data)
      } else if (!data || data.length === 0) {
        this.documentNumber.error = false
      }
    }
  },
  methods: {
    ...mapActions('companies', [ 'postAdminCompany' ]),
    handleSubmit () {
      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.$emit('handleSubmit', this.form)
        }
      }).catch(() => {
        this.submitted = false
      })
    },
    handleDocumentNumber (data) {
      this.documentNumber.disabled = true
      this.documentNumber.error = false

      this.postAdminCompany(data)
        .then(response => {
          /* TODO HANDLE COMPANY */
          this.$emit('handleCompany', response.document_number)
        })
        .catch(error => {
          this.documentNumber.error = error
          this.documentNumber.disabled = false
        })
    }
  }
};
</script>

<style lang="scss">
@import '@/scss/components/forms/ScopedForms';
</style>
